export default {
  querySaleList: '/gateway/capp/mallcenter/PropSaleForAppRpcService/querySaleList'
}
